export default __webpack_public_path__ + "static/media/bg.9e38ff38.webp";